<template>
  <a-modal dialogClass="file-modal" v-model="modelVisible" width="800px" :title="title" :footer="null"
           @cancel="handleClose" destroyOnClose>
    <!-- <template slot="title">
      <div class="dialog-title ellipsis">
        <div style="width: calc(100% - 20px);display: inline;">
          文件预览({{ file.name }})
        </div>
        <div class="full-screen__menu" @click="fullscreen? fullscreen=false: fullscreen=true">
          <i class="el-icon-full-screen"></i>
        </div>
      </div>
    </template> -->

    <!-- 图片 -->
    <div v-if="fileType===4">
      <div style="text-align:center;padding:10px 40px 10px 40px;height: 70vh;">
        <span >{{file.name ||''}}</span>
        <img :src="file.url" style="width:100%;height:100%;background-color:#FFF;object-fit:contain;margin-top: 10px"   @click="prevImg(file.url)"/>

      </div>
    </div>
    <!-- 音频 -->
    <div v-else-if="fileType===5">
      <span >{{file.name ||''}}</span>
      <div style="text-align:center;padding:40px;">
        <audio :src="file.url" autoplay="autoplay" controls="controls" loop="loop"></audio>
      </div>
    </div>
    <!-- 视频 -->
    <div v-else-if="fileType===6">
      <ts-new style="padding-top:40px;height:85vh;" :videos="videoList"></ts-new>
    </div>

    <div v-else>
      <a-spin :spinning="loading">
        <div :style="'padding-top:40px;' + frameHeight">
          <iframe :src="`${previewUrl}onlinePreview?url=${encodeURIComponent(base64Encode(file.url))}`"
                  width="100%" height="100%" @load="onload"></iframe>
        </div>
      </a-spin>
    </div>
    <!-- <div style="text-align: right;margin-top: 5px">
      <a-button size="small" @click="handleClose" class="raise">关闭</a-button>
    </div> -->
  </a-modal>
</template>

<script>
import { isImg, isAudio, isVideo } from '@/utils/getFileInfo.js'
import tsNew from '@/views/books/components/tsNew.vue'

export default {
  name: 'OfficePreview',
  props: {
    title: {
      type: String,
      default: '预览'
    },
    visible: {
      type: Boolean,
      default: false
    },
    // file:{name:'',url:''}
    file: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      modelVisible: this.visible,
      // 全屏
      fullscreen: false,
      // 文件类型
      fileType: 1,
      videoList: [],
      loading: true,
      frameHeight: 'height:83vh;',
      previewUrl: this.$previewUrl
    }
  },
  methods: {
    base64Encode (url) {
      // 后台转换接口会根据文件链接来判断文件类型，如果不含类型，则需要手动指明fullfilename
      if (!this.fileType && url.includes('easemob.com')) {
        url += (url.includes('?') ? '&' : '?') + 'fullfilename=' + encodeURIComponent(this.file.name)
      }
      console.log(url)
      const encoder = new TextEncoder()
      const uint8Array = encoder.encode(url)
      const base64String = btoa(String.fromCharCode.apply(null, uint8Array))

      // return url;
      // return window.btoa(url);
      return base64String
    },

    onload () {
      this.loading = false
    },

    handleClose () {
      this.$emit('update:visible', false)
    },

    /**
     * 获取文件类型
     * @return {null|number}
     */
    getFileType () {
      if (!this.file || !this.file.url) {
        return null
      }

      const fileName = this.file.url.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
      const fileNameLength = this.file.url.length // 取到文件名长度
      const fileFormat = this.file.url.substring(fileName + 1, fileNameLength).toLowerCase()
      // console.log(fileFormat);
      if (fileFormat === 'pdf') {
        return 1
      } else if (fileFormat === 'docx' || fileFormat === 'doc') {
        return 2
      } else if (fileFormat === 'xlsx' || fileFormat === 'xls') {
        return 3
      } else if (isImg(fileFormat)) {
        return 4
      } else if (isAudio(fileFormat)) {
        return 5
      } else if (isVideo(fileFormat)) {
        this.videoList = []
        this.videoList.push({ path: this.file.url, type: fileFormat })
        return 6
      }
      return null
    },
    renderedHandler () {
      console.log('渲染完成')
    },
    errorHandler () {
      console.log('渲染失败')
    },
    prevImg (url) {
      // console.log(this.images)
      // const paths = this.images.map(item => this.$resBasePath + '/' + item.path);
      const paths = [url]
      console.log(paths)
      this.$viewerApi({
        images: paths,
        initialViewIndex: 0,
        options: { initialViewIndex: 0 }
      }).view(0)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fileType = this.getFileType()
      // console.log(this.file);
    })
  },

  components: {
    tsNew
  }
}
</script>

<style scoped>
.dialog-title {
  text-align: center;
  display: flex;
  font-size: 18px;
  width: calc(100% - 30px);
}
</style>
<style>
.file-modal {
  top: 50px;
}
</style>
